import { createMuiTheme } from "@material-ui/core/styles";
import primaryColor from "./primaryColor";
import { esES } from "@material-ui/core/locale";

//Configuración del tema para definir los colores de diferentes elementos de MaterialUI
const theme = createMuiTheme(
  {
    palette: {
      primary: primaryColor,
    },
    typography: {
      button: {
        textTransform: "none",
      },
    },
    overrides: {
      MuiCardHeader: {
        root: {
          backgroundColor: primaryColor.main,
          color: primaryColor.contrastText,
          borderColor: primaryColor.main,
          borderStyle: "solid",
        },
      },
      MuiCard: {
        root: {
          borderColor: primaryColor.main,
        },
      },
    },
  },
  esES
);

export default theme;
